module.exports = __webpack_public_path__ + "assets/img/s3-tab-1-38f6acf8.png";